export default __webpack_public_path__ + "static/media/profile.54c76d43.png";